var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center h-full"},[_c('vs-button',{staticClass:"mr-2",attrs:{"color":"primary","type":"border","icon-pack":"feather","icon":"icon-eye"},on:{"click":_vm.hanldeViewSidebar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }